var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "van-dialog",
    {
      staticClass: "common-dialog",
      attrs: {
        "show-confirm-button": false,
        "show-cancel-button": false,
        "close-on-click-overlay": _vm.closeOnClickOverlay,
      },
      on: { close: _vm.handleClose },
      model: {
        value: _vm.dialogVisible,
        callback: function ($$v) {
          _vm.dialogVisible = $$v
        },
        expression: "dialogVisible",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "text-center text-lg font-medium text-gray-800 mb-4 px-4 pt-4",
          class: { "pb-4": !_vm.title.length },
        },
        [
          _vm.title ? _c("span", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
          _vm.closeable
            ? _c("van-icon", {
                staticClass: "absolute top-4 right-4 z-10",
                attrs: { name: "cross", size: "26" },
                on: { click: _vm.handleClose },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("div", { staticClass: "px-6 pb-4" }, [
        _vm.content && !_vm.$slots.default
          ? _c(
              "div",
              {
                staticClass:
                  "text-center text-gray-600 text-sm leading-relaxed mb-6",
              },
              [_vm._v(" " + _vm._s(_vm.content) + " ")]
            )
          : _vm._e(),
        _vm.$slots.default
          ? _c("div", { staticClass: "mb-6" }, [_vm._t("default")], 2)
          : _vm._e(),
        _vm.buttons && _vm.buttons.length > 0
          ? _c(
              "div",
              { staticClass: "flex space-x-10" },
              _vm._l(_vm.buttons, function (button, index) {
                return _c(
                  "button",
                  {
                    key: index,
                    class: _vm.getButtonClass(button),
                    on: {
                      click: function ($event) {
                        return _vm.handleButtonClick(button, index)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(button.text) + " ")]
                )
              }),
              0
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }